import React, { useState, useEffect } from 'react';
import checkIcon from '../../../assets/images/check.png';
import errorIcon from '../../../assets/images/error.png';
import infoIcon from '../../../assets/images/info.png';
import warningIcon from '../../../assets/images/warning.png';
import PropTypes from 'prop-types';

import {
  Container, Row, Col, Table, Input, FormGroup, Form, Label, CustomInput, Card,
  CardBody, Nav, NavItem, NavLink, Badge, Checkboxes, DropdownItem, ButtonGroup,
  DropdownToggle, DropdownMenu, Dropdown, UncontrolledTooltip, Spinner, Button
} from 'reactstrap';

import '../../../assets/css/Toast.css';
const TypeToast = [
  { title: 'Success', backgroundColor: '#5cb85c', icon: checkIcon },
  { title: 'Danger', backgroundColor: '#d9534f', icon: errorIcon },
  { title: 'Error', backgroundColor: '#d9534f', icon: errorIcon },
  { title: 'Info', backgroundColor: '#5bc0de', icon: infoIcon },
  { title: 'Warning', backgroundColor: '#f0ad4e', icon: warningIcon },
  { title: 'Processing', backgroundColor: '#f0ad4e', icon: infoIcon }
]

export const newToast = (message, typeToast, showLoadingWheel = false, options = {}) => {
  let re = TypeToast.find(t => t.title === typeToast);
  const id = Math.floor((Math.random() * 101) + 1);
  let design = { id: id, description: message };
  if (showLoadingWheel) {
    design.showLoadingWheel = true;
  }
  if (options.title) {
    design.title = options.title;
  }
  if (options.persistent) {
    design.persistent = true;
  }
  if (options.blocking) {
    design.blocking = true;
  }
  if (options.dismissible === false) {
    design.dismissible = false;
  }
  let leToast = { ...re, ...design };
  return leToast;
};

/** Sticky blocking toast for in-flight / do-not-resubmit payment states. */
export const newPaymentProcessingToast = ({ doNotResubmit = false, isBulkPayment = false } = {}) => {
  const title = doNotResubmit ? 'Payment is processing' : 'Processing your payment';
  let message = doNotResubmit
    ? 'Do not resubmit. Contact support if you do not see a confirmation.'
    : 'Please wait. Do not refresh or close this page.';
  if (isBulkPayment && !doNotResubmit) {
    message += ' Large payments may take up to a minute.';
  }
  return newToast(message, 'Processing', !doNotResubmit, {
    title,
    persistent: true,
    blocking: true,
    dismissible: false,
  });
};

const Toast = props => {
  const { toastList, position, autoDelete, autoDeleteTime } = props;
  const [list, setList] = useState(toastList);

  useEffect(() => {
    setList([...toastList]);

    // eslint-disable-next-line
  }, [toastList]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoDelete && toastList.length && list.length) {
        const deletable = list.find((t) => !t.persistent);
        if (deletable) {
          deleteToast(deletable.id);
        }
      }
    }, autoDeleteTime);

    return () => {
      clearInterval(interval);
    }

    // eslint-disable-next-line
  }, [toastList, autoDelete, autoDeleteTime, list]);

  const hasBlockingToast = list.some((t) => t.blocking);

  const deleteToast = id => {
    const listItemIndex = list.findIndex(e => e.id === id);
    const toastListItem = toastList.findIndex(e => e.id === id);
    list.splice(listItemIndex, 1);
    toastList.splice(toastListItem, 1);
    setList([...list]);
  }

  return (
    <>
      {hasBlockingToast && <div className="toast-blocking-backdrop" aria-hidden="true" />}
      <div className={`notification-container ${position}`}>
        {
          list.map((toast, i) =>
            <div
              key={i}
              className={`notification toast ${position}${toast.persistent ? ' toast-persistent' : ''}`}
              style={{ backgroundColor: toast.backgroundColor }}
            >
              {toast.dismissible !== false && (
                <button type="button" onClick={() => deleteToast(toast.id)}>
                  X
                </button>
              )}
              <div className="notification-image">
                {toast.showLoadingWheel &&
                  <Spinner variant="light" size="lg" />
                }
              </div>
              <div className="notification-image">
                <img src={toast.icon} alt="" />
              </div>
              <div>
                <p className="notification-title">{toast.title}</p>
                <p className="notification-message">
                  {toast.description}
                </p>
              </div>
            </div>
          )
        }
      </div>
    </>
  );
}

Toast.propTypes = {
  toastList: PropTypes.array.isRequired,
  position: PropTypes.string,
  autoDelete: PropTypes.bool,
  autoDeleteTime: PropTypes.number
}

export default Toast;
